/**
 * 选择买家经销商
 * props: maxChoose {Number}[可选]  最多可以选择几个经销商, 不传为不设限
 *        onChange {Function}[可以不传] 每次变更已选择的经销商 将values值和options值传过去
 *                @argument 传的话 参数为 {values, options} values: 已选经销商的values值 options: 已选经销商的options值
 *                @argument 不传的话 可以 通过rooteState.searchDealers.checkedValues获取 已选经销商的values值
 *                @argument 不传的话 可以 通过rooteState.searchDealers.checkedOptions获取 已选经销商的options值
 *        title    {string} [可选] 标题，默认为买家经销商名称；
 *        choosedTitle {string} [可选] 已选择部分的标题，默认为已选经销商；
 *        tipTitle {string} [可选] 没有选择多选框时，提示文案中的标题，默认为title去除‘名称’后的文案：买家经销商；
 *        showCheckAll {boolean} [可选] 是否可以全选搜索结果；默认否；！！！当maxChoose有值的时候，不能全选；
 * @argument 考虑到存在maxChoose时是否能够全选是动态的，暂不提供存在maxChoose时的全选功能；
 */
import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { Input, Checkbox } from 'antd';
import CheckGroup from './components/CheckGroup';
import { Root, Tip, ErrorTip, PreIcon } from '@/components/SearchDealers/style';
import { judgeArr } from '../../shared/functions';
const Search = Input.Search;
// Checkbox.Group是为了引入样式，antd的此组件没有点击事件；
const CheckboxGroup = Checkbox.Group;
const mapStateToProps = (rootState) => ({
    _state: rootState.searchDealers,
});
class SearchDealers extends Component {
    constructor() {
        super(...arguments);
        this.onInputChange = (e) => {
            dispatch.searchDealers.set_searchValue(e.target.value);
            const _e = e.target.value.trim();
            if (_e === '') {
                dispatch.searchDealers.TRUE_EMPTY_NAME();
            }
            else {
                dispatch.searchDealers.FALSE_EMPTY_NAME();
            }
        };
        this.onSearch = (e) => {
            const _e = e.trim();
            if (_e !== '') {
                dispatch.searchDealers.onSearch(_e);
            }
        };
        this.onCheckChange = (e) => {
            const { maxChoose, onChange } = this.props;
            dispatch.searchDealers.onCheckChange({ e, maxChoose, onChange });
        };
        this.onCheckedChange = (e) => {
            const { onChange } = this.props;
            dispatch.searchDealers.onCheckedChange({ e, onChange });
        };
        this.onCheckAllChange = (e) => {
            dispatch.searchDealers.onCheckAllChange(e.target.checked);
        };
    }
    componentWillUnmount() {
        dispatch.searchDealers.RESET_STATE();
    }
    render() {
        const { checkOptions, checkValues, checkedOptions, checkedValues, error, indeterminate, checkAll, emptyName, searchValue, } = this.props._state;
        const { title, choosedTitle, tipTitle, showCheckAll, maxChoose } = this.props;
        const dealTitle = tipTitle ? tipTitle : title.replace(/名称/g, '');
        return (<Root>
                <div className="flex__row-start relative com_t">
                    <PreIcon />
                    <span>{title}：</span>
                    <div className="search__container">
                        <Search placeholder={`请输入${title}`} enterButton onSearch={this.onSearch} onChange={this.onInputChange} value={searchValue}/>
                    </div>
                </div>
                
                {emptyName && <ErrorTip className="search--result">请输入{title}</ErrorTip>}
                
                
                {showCheckAll && !maxChoose &&
            <Checkbox className="check--all" indeterminate={indeterminate} onChange={this.onCheckAllChange} checked={checkAll}>
                    全选此次搜索结果
                  </Checkbox>}
                {judgeArr(checkOptions) &&
            <CheckGroup className="checkBox--result" options={checkOptions} onChange={this.onCheckChange} value={checkValues} isGrid/>} {!judgeArr(checkOptions) &&
            <Tip className="search--result">暂无搜索结果</Tip>}
                
                <div className="choose__title relative com_t"><PreIcon />{choosedTitle}：</div>
                {judgeArr(checkedOptions) &&
            <CheckGroup className="checkBox--choose" options={checkedOptions} onChange={this.onCheckedChange} value={checkedValues}/>} {!judgeArr(checkedOptions) && !error &&
            <Tip>您还没有选择{dealTitle}</Tip>}{!judgeArr(checkedOptions) && !!error &&
            <ErrorTip>请选择{dealTitle}</ErrorTip>}
            </Root>);
    }
}
SearchDealers.defaultProps = {
    title: '买家经销商名称',
    choosedTitle: '已选经销商',
    showCheckAll: false,
};
export default connect(mapStateToProps)(SearchDealers);
